enum SupportedLanguage {
    English = "en-US",
    French = "fr-CA",
    Spanish = "es-ES",
    German = "de",
    Portuguese = "pt-BR",
    Italian = "it",
    Dutch = "nl",
    Korean = "ko"
}

export default SupportedLanguage;